import * as am5 from '@amcharts/amcharts5';
import * as am5map from '@amcharts/amcharts5/map';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import am5themes_Responsive from '@amcharts/amcharts5/themes/Responsive';
import { ElementRef } from '@angular/core';
import { LtGeoData } from '../../models';

export function createGraph(
    container: ElementRef<any>,
    geoJSON: any,
    data: LtGeoData[],
) {
    /* Chart code */
    // Create root
    let root = am5.Root.new(container.nativeElement);

    const responsive = am5themes_Responsive.new(root);

    responsive.addRule({
        relevant: function (width, height) {
            return width < 768;
        },
        applying: function () {
            polygonSeries.mapPolygons.template.setAll({
                strokeWidth: 2,
            });
        },
        removing: function () {
            polygonSeries.mapPolygons.template.setAll({
                strokeWidth: 4,
            });
        },
    });

    // Set themes
    root.setThemes([am5themes_Animated.new(root), responsive]);
    // Create chart
    let chart = root.container.children.push(
        am5map.MapChart.new(root, {
            panX: 'none',
            panY: 'none',
            wheelX: 'none',
            wheelY: 'none',
            projection: am5map.geoAlbersUsa(),
            layout: root.horizontalLayout,
        }),
    );

    // Create polygon series
    let polygonSeries = chart.series.push(
        am5map.MapPolygonSeries.new(root, {
            geoJSON,
            valueField: 'value',
        }),
    );

    let tooltip = am5.Tooltip.new(root, {
        getFillFromSprite: false,
        getStrokeFromSprite: true,
    });

    tooltip.get('background').setAll({
        fill: am5.color('#000000'),
        fillOpacity: 0.8,
    });

    polygonSeries.mapPolygons.template.setAll({
        tooltipHTML: getTooltipHtml(),
        stroke: am5.color('#192129'),
        strokeWidth: 4,
        templateField: 'polygonSettings',
        tooltip,
        
    });

    polygonSeries.data.setAll([...data]);
}

function getTooltipHtml() {
    return `
    <section class="text-white">
        <span class="font-body-2-strong">{geoCode} Load-to-Truck Ratio:</span>
        <span class="font-body-2">{valueFormatted}</span>
    </section>
    `;
}
